import React from "react";
import { Link } from "react-router-dom";
import "./home.scss";
import Static from "./Static";
import Filter from "./Filter";
import Rank from "./Rank";
import Selected from "./Selected";
import Modal from "./Modal";

export default function Home() {
  return (
    <>
      <Static />
      <Filter />
      <Rank />
      <Link className="to_form_btn" to="form/">
        <b>お届け先の入力</b>
      </Link>
      <Selected />
      <Modal />
    </>
  );
}
